const generateFetchMusicQueryParams = (
  movieId: string,
  country: string,
  translation: string,
  assetSubType: string
) => {
  const queryParams = {
    filter: {
      id: movieId,
      page: 1,
      limit: 25,
      country,
      translation,
      assetSubType: assetSubType,
      sortBy: 'release_date',
      version: '2',
      sortOrder: 'desc'
    }
  };

  return queryParams;
};

export default generateFetchMusicQueryParams;
